export const noteAutocomplete = function noteAutocomplete(partial) {
  if (!partial || partial.length < 2) return []

  var terms = [
    // Procedures
    { en: 'Composite Filling', ka: 'კომპოზიტური ბჟენი', category: 'procedure' },
    { en: 'Root Canal Treatment', ka: 'ფესვის არხის მკურნალობა', category: 'procedure' },
    { en: 'Scaling', ka: 'სკეილინგი', category: 'procedure' },
    { en: 'Crown Preparation', ka: 'გვირგვინის პრეპარაცია', category: 'procedure' },
    { en: 'Extraction', ka: 'ექსტრაქცია', category: 'procedure' },
    { en: 'Implant Placement', ka: 'იმპლანტის დაყენება', category: 'procedure' },
    { en: 'Veneer Preparation', ka: 'ვინირის პრეპარაცია', category: 'procedure' },
    { en: 'Bridge Preparation', ka: 'ხიდის პრეპარაცია', category: 'procedure' },
    { en: 'Bone Grafting', ka: 'ძვლის გადანერგვა', category: 'procedure' },
    { en: 'Sinus Lift', ka: 'სინუს ლიფტი', category: 'procedure' },
    { en: 'Teeth Whitening', ka: 'კბილების გათეთრება', category: 'procedure' },
    { en: 'Root Planing', ka: 'ფესვის მოშრიალება', category: 'procedure' },
    { en: 'Frenectomy', ka: 'ფრენექტომია', category: 'procedure' },
    { en: 'Pulpotomy', ka: 'პულპოტომია', category: 'procedure' },
    { en: 'Apicoectomy', ka: 'აპიკოექტომია', category: 'procedure' },

    // Findings
    { en: 'Caries', ka: 'კარიესი', category: 'finding' },
    { en: 'Periodontitis', ka: 'პერიოდონტიტი', category: 'finding' },
    { en: 'Gingivitis', ka: 'გინგივიტი', category: 'finding' },
    { en: 'Abscess', ka: 'აბსცესი', category: 'finding' },
    { en: 'Fracture', ka: 'ფრაქტურა', category: 'finding' },
    { en: 'Erosion', ka: 'ეროზია', category: 'finding' },
    { en: 'Recession', ka: 'რეცესია', category: 'finding' },
    { en: 'Pulpitis', ka: 'პულპიტი', category: 'finding' },
    { en: 'Malocclusion', ka: 'მალოკლუზია', category: 'finding' },
    { en: 'Bruxism', ka: 'ბრუქსიზმი', category: 'finding' },
    { en: 'Periapical Lesion', ka: 'პერიაპიკალური დაზიანება', category: 'finding' },
    { en: 'Calculus', ka: 'კალკულუსი', category: 'finding' },
    { en: 'Mobility', ka: 'მობილობა', category: 'finding' },

    // Materials
    { en: 'Composite Resin', ka: 'კომპოზიტური ფისი', category: 'material' },
    { en: 'Glass Ionomer', ka: 'მინა იონომერი', category: 'material' },
    { en: 'Amalgam', ka: 'ამალგამა', category: 'material' },
    { en: 'Zirconia', ka: 'ცირკონია', category: 'material' },
    { en: 'Porcelain', ka: 'ფაიფური', category: 'material' },
    { en: 'Titanium', ka: 'ტიტანი', category: 'material' },
    { en: 'Gutta Percha', ka: 'გუტა პერჩა', category: 'material' },
    { en: 'PVS Impression Material', ka: 'PVS ანაბეჭდის მასალა', category: 'material' },
    { en: 'Calcium Hydroxide', ka: 'კალციუმის ჰიდროქსიდი', category: 'material' },

    // Medications
    { en: 'Amoxicillin', ka: 'ამოქსიცილინი', category: 'medication' },
    { en: 'Ibuprofen', ka: 'იბუპროფენი', category: 'medication' },
    { en: 'Chlorhexidine', ka: 'ქლორჰექსიდინი', category: 'medication' },
    { en: 'Lidocaine', ka: 'ლიდოკაინი', category: 'medication' },
    { en: 'Metronidazole', ka: 'მეტრონიდაზოლი', category: 'medication' },
    { en: 'Clindamycin', ka: 'კლინდამიცინი', category: 'medication' },
    { en: 'Articaine', ka: 'არტიკაინი', category: 'medication' },
    { en: 'Dexamethasone', ka: 'დექსამეთაზონი', category: 'medication' }
  ]

  var query = partial.toLowerCase()
  var matches = []

  for (var i = 0; i < terms.length; i++) {
    var term = terms[i]
    var enLower = term.en.toLowerCase()
    var kaLower = term.ka.toLowerCase()
    if (enLower.indexOf(query) !== -1 || kaLower.indexOf(query) !== -1) {
      matches.push(term)
    }
    if (matches.length >= 5) break
  }

  return matches
}
